import React from 'react'
import GalleryComponent from '../../components/GalleryComponent/GalleryComponent'
import SafariBlog from '../../components/SafariBlog/SafariBlog'

import gallery_1 from '../../assets/images/sinharaja-1.jpg'
import gallery_2 from '../../assets/images/sinharaja-2.jpg'
import gallery_3 from '../../assets/images/sinharaja-3.jpg'
import gallery_4 from '../../assets/images/sinharaja-4.webp'
import gallery_5 from '../../assets/images/sinharaja-5.jpg'
import gallery_6 from '../../assets/images/sinharaja-6.webp'
import gallery_7 from '../../assets/images/sinharaja-7.webp'
import gallery_8 from '../../assets/images/sinharaja-8.jpg'
import gallery_9 from '../../assets/images/sinharaja-9.jpg'
import gallery_10 from '../../assets/images/sinharaja-10.webp'
import gallery_11 from '../../assets/images/sinharaja-11.jpg'
import gallery_12 from '../../assets/images/sinharaja-12.jpg'


const descriptions = [
    'Explore the captivating beauty of Sinharaja Rainforest, a UNESCO World Heritage Site and a haven for wildlife enthusiasts and photographers alike. This tropical paradise spans 11,000 hectares and offers a rich tapestry of Sri Lanka’s biodiversity.',

    'Sinharaja is a paradise for wildlife photographers, offering thrilling opportunities to capture unique moments. Spor the purple faced leaf monkey, striped necked mongoose giant squirrel and if you are lucky enough the slender loris. Photograph colorful birds like the Red-faced Malkoha and Layard’s Parakeet, Chestnut backed owlet, serendib scops owl, Forest eagle owl, ceylon bay owl and capture the graceful movements of the Sri Lanka Blue Magpie.',

    'In addition to wildlife, Sinharaja boasts stunning botanical wonders. Photograph towering trees like Dipterocarpus zeylanicus and Artocarpus nobilis, and focus on the delicate beauty of plants like Mesua nagassarium (Ironwood) and Calophyllum walkeri (Domba).',

    'The journey to Sinharaja, about 160 kilometers from Colombo, is an experience in itself. As you leave urban landscapes behind, immerse yourself in the soothing sounds of nature, setting the stage for your photographic adventure.',

    'Plan a full day for your expedition, allowing time to explore forest trails, discover hidden waterfalls, and capture the symphony of birdsong. Sinharaja Rainforest invites photographers to witness its untouched beauty, where each click tells a story of Sri Lanka’s natural heritage.',
  ];

const wildlife_photography = () => {

    const items = [
        { xs: 4, imgSrc: gallery_1 },
        { xs: 4, imgSrc: gallery_2 },
        { xs: 4, imgSrc: gallery_3 },
        { xs: 3.5, imgSrc: gallery_4 },
        { xs: 5, imgSrc: gallery_5 },
        { xs: 3.5, imgSrc: gallery_6 },
        { xs: 3.5, imgSrc: gallery_7 },
        { xs: 4.5, imgSrc: gallery_8 },
        { xs: 4, imgSrc: gallery_9 },
        { xs: 4, imgSrc: gallery_10 },
        { xs: 4, imgSrc: gallery_11 },
        { xs: 4, imgSrc: gallery_12 },
    ];

  return <div className='__black'>
    <SafariBlog
        heading='Sinharaja Bird Watching'
        description={descriptions}
        to='/contact'
    />
    <div className="w-1">
        <GalleryComponent imgStyle={{padding:'10px', height:'40vh'}} items={items} />;
    </div>
  </div>
}

export default wildlife_photography